import { useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchPicklistOptions } from "store/actions/picklists";

export const usePicklistOptions = picklistId => {
	const { options, isFetching, hasError } = useSelector(state => state.picklists[picklistId] || {});

	useEffect(() => {
		if (!isFetching) {
			fetchPicklistOptions(picklistId);
		}
	}, []);

	return { options, isFetching, hasError };
};

export default usePicklistOptions;
